import { AppConst } from 'src/app/shared/constants/app-const';
import { WindLatestSiteData } from 'src/app/shared/interfaces/latest-site-data';
import { SensorHistory } from 'src/app/shared/interfaces/sensor-history';

import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AreaChartComponent, LegendPosition } from '@swimlane/ngx-charts';

import {
  LineChartResultDto,
  LineChartResultSeriesDto,
} from '../../charts.interface';
import { ChartsService } from '../../charts.service';

@Component({
  selector: 'app-wind-line-chart',
  templateUrl: './wind-line-chart.component.html',
  styleUrls: ['./wind-line-chart.component.scss'],
})
export class WindLineChartComponent implements OnChanges {
  @Input() data: WindLatestSiteData = {} as WindLatestSiteData;
  @Input() chartRange: string = 'daytime';
  @ViewChild(AreaChartComponent) chart: AreaChartComponent | null = null;

  results: LineChartResultDto[] = [];

  // Line chart options
  view: [number, number] = [600, 400];
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  legendTitle = '風速 (m/s)';
  legendPosition = LegendPosition.Below;
  showXAxisLabel = false;
  xAxisLabel = 'Year';
  showYAxisLabel = false;
  yAxisLabel = 'Population';
  yScaleMin = 0;
  yScaleMax = AppConst.LINE_CHART_Y_SCALE_MAX;

  colorScheme = 'cool';
  lineColor = '#9C27B0';
  customColors = (value: string) => {
    return this.lineColor;
  };

  timeline = true;

  sensorId = '';
  dataList: LineChartResultSeriesDto[] = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private chartsService: ChartsService
  ) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.sensorId = this.data.id;
    this.setChartWidth();

    const histories = await this.getHistories();
    this.clearAllData();
    this.createDataSets(histories);

    // 表示対象風速データの最大値が10を超えていたら、グラフの縦軸もそれに合わせる
    const maxSpeed = this.getMaxSpeed(histories);
    if (maxSpeed > AppConst.LINE_CHART_Y_SCALE_MAX) {
      this.yScaleMax = maxSpeed;
    }

    // console.log(this.wbgtDataList.length);

    this.results = [];
    this.results.push({
      name: '風速',
      series: this.dataList,
    });

    if (this.chart) {
      this.chart.update();
    }
  }

  onResize(event: UIEvent) {
    this.setChartWidth();
  }

  setChartWidth() {
    this.view[0] = this.chartsService.getChartWidthFromWindowWidth(
      window.innerWidth
    );
  }

  onSelect(event: any) {}

  async getHistories() {
    let histories: SensorHistory[] | null = null;
    if (this.chartRange === '' || this.chartRange === 'daytime') {
      histories = await this.chartsService.getDaytimeSensorHistory(
        this.sensorId
      );
    } else if (this.chartRange === 'day') {
      histories = await this.chartsService.getDaySensorHistory(this.sensorId);
    } else if (this.chartRange === 'week') {
      histories = await this.chartsService.getWeekSensorHistory(this.sensorId);
    } else if (this.chartRange === 'month') {
      histories = await this.chartsService.getMonthSensorHistory(this.sensorId);
    }

    return histories;
  }

  getMaxSpeed(histories: SensorHistory[] | null) {
    if (histories === null) return 0;

    const speeds: number[] = [];
    for (let history of histories) {
      if (history.windSpeed !== undefined) {
        speeds.push(history.windSpeed);
      }
    }

    return Math.max.apply(null, speeds);
  }

  createDataSets(histories: SensorHistory[] | null) {
    if (histories === null) return;

    const result = this.chartsService.createWindChartDataSets(
      this.chartRange,
      histories
    );
    if (result !== undefined) {
      this.dataList = result.speed;
    }
  }

  clearAllData() {
    this.dataList = [];
  }
}
